import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { ExtraService } from '../../core/services/extra.service';
import { ContentService } from '../../core/services/content.service';
import { SessionService } from '../../core/services/session.service';
import { Content } from '../../core/models/content';
import * as firebase from 'firebase/app';

import { ContentFileUpload } from '../../core/models/content-files-upload';

@Component({
  selector: 'app-content-add',
  templateUrl: './content-add.component.html',
  styleUrls: ['./content-add.component.css'],
  providers: [ContentService,SessionService,ExtraService]
})
export class ContentAddComponent implements OnInit {

  @ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;
  
  pageTitle: string = 'Content Add';
  pageAlias: string = 'content-form';
  disableButton:boolean=true;
  eventId: string;
  contentID: string;
  session_name: string;
  imageFile: File = null;

  errorMessage = new Array<string>();
  isError: boolean = false;
  message: string = '';
  uploadComplete:number;

  //sessionList = new Array<any>();
  contentList: Array<Content> = new Array();
  content = new Content();
  currentFileUpload = ContentFileUpload;

  constructor(private extraService:ExtraService,private route: ActivatedRoute,
    private _cfr: ComponentFactoryResolver, private router:Router,private contentService: ContentService,private sessionService: SessionService) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
      this.extraService.changeSideBar(true);
      this.route.queryParams.subscribe(params => {
        if(params['eventId'] && (!params['contentId'])) {
          this.eventId = params['eventId'];
          this.extraService.setCurrentEventId(params['eventId']);
          this.getContntList(params['eventId']);
        } 
        if(params['eventId'] && params['contentId']) {
            this.eventId = params['eventId'];
            this.contentID = params['contentId'];
            this.extraService.setCurrentEventId(params['eventId']);
            this.setContentDetails(this.eventId, this.contentID);
        }
      });
  }

  sessionId: string;
  setContentDetails(eventId, contentId) {
    this.contentService.getContentDetail(eventId, contentId).subscribe(result=>{
      if(result) {
        this.content = result;
        if(result.sessionId) {
          this.sessionId = result.sessionId;
        }
      }
      
    });
  }

  getContntList(id) {
    this.message = null;
    var x = this.contentService.getContentList(id);
      x.snapshotChanges().subscribe(list=>{
      //this.contactIdList = new Array();
      this.contentList = new Array();
      list.forEach(element =>{
        var y = element.payload.toJSON() as Content ;
        y["$key"] = element.key;
        this.contentList[y.position] = (y as Content);
        console.log(this.contentList)
      });
    });
  }

  //recievesessionId:string;
  receiveSession($event) {
    if($event.prop) {
      this.isError = false;
      this.errorMessage = new Array();
      this.content.contentType = $event.prop;
    }
    
    this.content.sessionId = $event.sessionId;
  }

  validate() {

    this.isError = false;
    this.errorMessage = new Array<string>();
    let valid = true;

    if(this.content.contentType == 'session' && !this.content.sessionId) {
      valid = false;
      this.isError = true;
      this.errorMessage.push("Please Select "+this.content.contentType);
    } else {
      valid = true;
    }
    return valid;
  }
  
  onBasicUpload(event) {
    this.imageFile = event.files[0];
  }

  deleteImage(){
    this.imageFile = null;
  }

  submit() {

    this.disableButton = false;
    if(this.validate()) {
    let content = this.content;
    this.content.eventId = this.eventId;
    
      if(!this.contentID) {
        if(this.imageFile != null) {
          this.disableButton = false;
          this.content.name = this.imageFile.name;
          this.content.filetype = this.content.name.split(".").pop();
          this.content.sizeInBytes = this.imageFile.size;

          let currentFileUpload = new ContentFileUpload(this.imageFile);
          let uploadTask = this.contentService.pushUpload(currentFileUpload, this.eventId);
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) =>  {
                this.message = "File Uploding...";
               this.uploadComplete =  Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100)
              },
            (error) => {
              this.errorMessage.push(error.message);
              this.disableButton = true;
              this.isError = true;
            },
            () => {
              //upload success
              this.message = "File Uploaded successfully";
              setTimeout(function() {}.bind(this), 1000);
              this.content.contentFileUrl = uploadTask.snapshot.downloadURL;
              this.content.position = this.contentList.length;
              let contentKey = this.contentService.addContentDetails(this.eventId, content);
              if(contentKey) {
                this.imageFile = null;
                this.message = "Content Added successfully";
                if(this.uploadComplete == 100) {
                  setTimeout(function() {
                    this.message = null;
                    this.disableButton = true;
                    this.router.navigate([Constants.CONTENT_FORM, this.eventId]);
                  }.bind(this), 2000);
                }
              }
            });
        } else {
          this.isError = true;
          this.errorMessage.push("Please select an image");
          this.disableButton = true;
        }
      } else {
        console.log('***********');
        console.log(this.eventId, content);
        this.disableButton = true;
        this.contentService.updateContentDetails(this.eventId, this.contentID, content).then(response=>{
          console.log(response);
          this.message = "Content Update successfully";
          setTimeout(function() {
            this.message = null;
            this.disableButton = true;
            this.router.navigate([Constants.CONTENT_FORM, this.eventId]);
          }.bind(this), 2000);

        }).catch(error=>{
          console.log(error.message);
        });
      }
    }  else {
      this.disableButton = true;
    }
  }

  
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/content-add/content-add.component.ts